var map = {
	"./decidim/avatar-multiuser.png": 49934,
	"./decidim/brands/facebook.svg": 29576,
	"./decidim/brands/google.svg": 82177,
	"./decidim/brands/twitter-x.svg": 25514,
	"./decidim/cc-badge.png": 30672,
	"./decidim/decidim-logo.svg": 76620,
	"./decidim/default-avatar.svg": 11252,
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": 5264,
	"./decidim/icons.svg": 14959,
	"./decidim/pattern.png": 38656,
	"./decidim/placeholder-card-g.svg": 36949,
	"./decidim/placeholder-card-l.svg": 93214,
	"./decidim/placeholder.jpg": 64845,
	"./decidim/remixicon.symbol.svg": 11841,
	"./decidim/vendor/social-share-button/douban.svg": 28256,
	"./decidim/vendor/social-share-button/email.svg": 62589,
	"./decidim/vendor/social-share-button/facebook.svg": 12035,
	"./decidim/vendor/social-share-button/google_bookmark.svg": 69869,
	"./decidim/vendor/social-share-button/hacker_news.svg": 99421,
	"./decidim/vendor/social-share-button/linkedin.svg": 5845,
	"./decidim/vendor/social-share-button/odnoklassniki.svg": 52966,
	"./decidim/vendor/social-share-button/pinterest.svg": 30595,
	"./decidim/vendor/social-share-button/reddit.svg": 27351,
	"./decidim/vendor/social-share-button/telegram.svg": 37690,
	"./decidim/vendor/social-share-button/tumblr.svg": 45945,
	"./decidim/vendor/social-share-button/twitter.svg": 97164,
	"./decidim/vendor/social-share-button/vkontakte.svg": 77234,
	"./decidim/vendor/social-share-button/wechat.svg": 78973,
	"./decidim/vendor/social-share-button/whatsapp.svg": 2413,
	"./decidim/vendor/social-share-button/x.svg": 3389,
	"./decidim/vendor/social-share-button/xing.svg": 77379
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 79057;